export default {
  apiUrl: '/api/notices',
  dataPath: 'result.rows',
  paginationPath: 'data',
  trackBy: 'id',
  detailRowComponentName: 'notice-editor',
  onEachSide: 1,
  preloadList: [],
  sortOrder: [{
    field: 'id',
    sortField: 'id',
    direction: 'DESC',
  }],
  paginationTemplate: {
    class: '',
    template: '총 {total}개 중의 {from} 부터 {to}',
  },
  fields: [
    {
      name: '__checkbox',
      titleClass: 'text-center',
      dataClass: 'text-center',
    },
    {
      name: '__slot:actions',
      title: '편집 삭제',
      titleClass: 'center aligned',
      dataClass: 'center aligned',
    },
    {
      name: 'id',
      title: '<p style="white-space: nowrap">아이디</p>',
      sortField: 'id',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'title',
      title: '<i style="white-space: nowrap">제목</i>',
      sortField: 'title',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'content_url',
      title: '<i style="white-space: nowrap">콘텐츠 URL</i>',
      sortField: 'content_url',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'begin_at',
      title: '<i style="white-space: nowrap">공개 날짜</i>',
      sortField: 'begin_at',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'tag',
      title: '<i style="white-space: nowrap">말머리</i>',
      sortField: 'tag',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'tag_bg_color',
      title: '<i style="white-space: nowrap">말머리 배경색</i>',
      sortField: 'tag_bg_color',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'summary',
      title: '<i style="white-space: nowrap">컨텐츠 요약</i>',
      sortField: 'summary',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'is_published',
      title: '<p style="white-space: nowrap">퍼블리싱</p>',
      sortField: 'is_published',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'toggleField',
    },
    {
      name: '__slot:actions',
      title: '편집 삭제',
      titleClass: 'center aligned',
      dataClass: 'center aligned',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/spa/components/board/notice/Config.js